import { lazy } from "react";

const routes = [
  {
    path: "/subModule",
    element: lazy(() => import("../../pages/ModulePersonalization/SubModule")),
  },
  {
    path: "/subModule/create",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubModule/create-editSubModule"),
    ),
  },
  {
    path: "/subModule/edit/:id",
    element: lazy(
      () =>
        import("../../pages/ModulePersonalization/SubModule/create-editSubModule"),
    ),
  },
];

export default routes;
